<template>
  <div>
    <div v-show="false">
      <h4 class="ui dividing header">
        <i class="plug icon"></i> {{ $t("connection settings") }}
      </h4>
      <div class="ui two column very relaxed grid">
        <div class="column">
          <div class="ui form">
            <h5 class="ui dividing header">{{ $t("local database") }}</h5>
            <div class="two fields">
              <div class="field">
                <label for="">{{ $t("user") }}</label>
                <input type="text" name="user1" v-model="config.user1" />
              </div>
              <div class="field">
                <label for="">{{ $t("password") }}</label>
                <input
                  type="password"
                  name="password1"
                  v-model="config.password1"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="ui form">
            <h5 class="ui dividing header">{{ $t("comparisson database") }}</h5>
            <div class="two fields">
              <div class="field">
                <label for="">{{ $t("host") }}</label>
                <input type="text" name="host2" v-model="config.host2" />
              </div>
              <div class="field">
                <label for="">{{ $t("database name") }}</label>
                <input
                  type="text"
                  name="database2"
                  v-model="config.database2"
                />
              </div>
            </div>
            <div class="two fields">
              <div class="field">
                <label for="">{{ $t("user") }}</label>
                <input type="text" name="user2" v-model="config.user2" />
              </div>
              <div class="field">
                <label for="">{{ $t("password") }}</label>
                <input
                  type="password"
                  name="password2"
                  v-model="config.password2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="ui vertical divider"></div> -->
    </div>
    <h4 class="ui dividing header">
      <i class="code icon"></i> {{ $t("script settings") }}
    </h4>
    <div class="ui icon menu">
      <a class="item" @click="check">
        <i class="lightning icon" v-bind:class="{ loading: processing }"></i>
        {{ $t("check") }}
      </a>
      <a class="item" @click="apply">
        <i class="check icon" v-bind:class="{ loading: processing }"></i>
        {{ $t("apply") }}
      </a>
      <div class="ui dropdown item" ref="script_options_dropdown">
        {{ $t("options") }}
        <i class="dropdown icon"></i>
        <div class="menu">
          <div class="item">
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="hide comments"
                v-model="hide_comments"
              />
              <label>{{ $t("ignore comments") }}</label>
            </div>
          </div>
          <div class="item">
            <div class="ui toggle checkbox">
              <input type="checkbox" name="toggle1" v-model="toggle_1" />
              <label>{{ $t("ignore charset update") }}</label>
            </div>
          </div>
          <div class="item">
            <div class="ui toggle checkbox">
              <input type="checkbox" name="toggle2" v-model="toggle_2" />
              <label>{{ $t("ignore auto increment update") }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <editor
      @init="init_editor"
      v-model="custom_script"
      lang="sql"
      theme="monokai"
    ></editor>
    <h5 class="ui dividing header">{{ $t("update log") }}</h5>
    <editor v-model="log" lang="text" theme="monokai"></editor>
  </div>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import Editor from "vue2-ace-editor";

export default {
  name: "SettingsSystemManagement",
  data() {
    return {
      processing: false,
      config: {
        user1: "root",
        password1: "DataBank1.",
        database1: "swissk_bk",
        host2: "206.189.185.12",
        user2: "strato",
        password2: "Yaniraileana",
        database2: "swissknife",
      },
      script: "",
      toggle_1: false,
      toggle_2: false,
      hide_comments: false,
      log: "",
    };
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
    custom_script() {
      let vm = this;
      let r = this.script;
      if (vm.toggle_1) {
        r = r.replace(
          /ALTER TABLE [a-zA-Z_]+ ENGINE=InnoDB DEFAULT CHARSET=utf8; .*\n/g,
          "",
        );
      }

      if (vm.toggle_2) {
        r = r.replace(
          /ALTER TABLE [a-zA-Z_]+ ENGINE=InnoDB AUTO_INCREMENT=[0-9]+ DEFAULT CHARSET=utf8; .*\n/g,
          "",
        );
      }

      if (vm.hide_comments) {
        r = r.replace(/#.*/g, "");
      }
      return r;
    },
  },
  components: { Editor },
  watch: {},
  methods: {
    check() {
      let vm = this;
      vm.processing = true;
      local_api(vm, "post", "/system/management/do-check-database", {
        config: vm.config,
      })
        .then((r) => {
          vm.script = r;
          vm.processing = false;
        })
        .catch((err) => {
          error_toast(err);
          vm.processing = false;
        });
    },
    init_editor() {
      require("brace/mode/sql");
      require("brace/theme/monokai");
    },
    apply() {
      let vm = this;
      vm.processing = true;
      let script = vm.custom_script;
      script = script.replace(/#.*/g, "").trim();
      let commands = script.split(";");
      if (commands) {
        let cmds = commands.map((c) => {
          let cmd = c.trim();
          if (cmd) {
            local_api(
              vm,
              "post",
              "/system/management/do-apply-database-script",
              {
                s: cmd,
              },
            )
              .then((r) => {
                vm.log += cmd + "\n" + r + "\n\n";
                vm.processing = false;
              })
              .catch((err) => {
                vm.log += cmd + "\n" + JSON.stringify(err, null, 2) + "\n\n";
                vm.processing = false;
              });
          }
        });
        console.log(cmds);
      }
    },
  },
  mounted() {
    window
      .jQuery(this.$refs.tabs)
      .find(".item")
      .tab();

    window.jQuery(this.$refs.script_options_dropdown).dropdown();
  },
};
</script>

<style scoped></style>
